import { CollapseData } from './../datatable-table/interfaces/collapse-data.interface';
import { DataTable, Sort } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, Renderer2, AfterViewInit, AfterContentChecked } from '@angular/core';

@Component({
  selector: 'app-custom-datatable-table',
  templateUrl: './custom-datatable-table.component.html',
  styleUrls: ['./custom-datatable-table.component.scss']
})
export class CustomDatatableTableComponent implements OnInit, AfterViewInit, AfterContentChecked {

  @Input() id: string;
  @Input() datatable: DataTable;
  @Input() loading: boolean;
  @Input() sorts: Sort[] = [];
  
  _data: any[];
  get data(): any[] {
    return this._data;
  }
  @Input() set data(data: any[]) {
    this._data = data;
    this.setCollapseData();
    if (this.scrolltopdiv && this.table) {
      this.changeScrollTopDiv();
    }
  }

  @Output() onSortCambiados = new EventEmitter<Sort[]>();

  collapseData: CollapseData[] = [];

  @ViewChild('scrolltop', { static: false }) scrolltop: ElementRef<any>;
  @ViewChild('tablewrapper', { static: false }) tablewrapper: ElementRef<any>;
  @ViewChild('scrolltopdiv', { static: false }) scrolltopdiv: ElementRef<any>;
  @ViewChild('table', { static: false }) table: ElementRef<any>;

  constructor(private _r: Renderer2) {
  }

  ngOnInit(): void {
    this.setCollapseData();
  }

  ngAfterContentChecked() {
    if (this.scrolltopdiv && this.table) {
      this.changeScrollTopDiv();
    }
  }

  ngAfterViewInit() {
    this.changeScrollTopDiv();

    this.scrolltop.nativeElement.onscroll = e => this.tablewrapper.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0)
    this.tablewrapper.nativeElement.onscroll = e => this.scrolltop.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0)
  }

  changeScrollTopDiv() {
    this._r.setStyle(this.scrolltopdiv.nativeElement, 'width', (this.table.nativeElement.offsetWidth || this.table.nativeElement.clientWidth) + 'px' );
  }

  setCollapseData() {
    if (this.datatable.collapsing && this.data && this.data.length > 0) {
      this.collapseData = this.data ? this.data.map(item => { return { 
        open: false,
        canCollapse: this.datatable.collapsing.collapse && this.datatable.collapsing.collapse(item)
      } }) : [];
      
      this.datatable.hooks.onCollapseData(this.collapseData);
    }
  }

  colspan() {
    return this.datatable.columnas.filter(x => x.mostrar !== false).length +
           (this.datatable.collapsing ? 1 : 0);
  }

  sortCambiados(sorts: Sort[]) {
    this.sorts = sorts;
    this.onSortCambiados.emit(this.sorts);
  }

}
